import React from "react";
import { ChipGroup } from "@porchpass/ui";
import type { ConditionFilter } from "src/api/preApproval/types";
import { formatStatusLabel } from "../../utils";

const FILTERS: ConditionFilter[] = [
  "all",
  "not_done",
  "in_progress",
  "in_review",
  "done",
  "correction_needed",
];

const FILTER_OPTIONS = FILTERS.map((filter) => ({
  value: filter,
  label: filter === "all" ? "All" : formatStatusLabel(filter),
}));

interface ConditionFilterChipsProps {
  value: ConditionFilter;
  onChange: (filter: ConditionFilter) => void;
}

export function ConditionFilterChips({
  value,
  onChange,
}: ConditionFilterChipsProps) {
  return (
    <ChipGroup
      options={FILTER_OPTIONS}
      value={value}
      onValueChange={(next) => {
        if (typeof next === "string" && next) {
          onChange(next as ConditionFilter);
        }
      }}
      variant="outline"
      size="sm"
    />
  );
}
